import type { LandingData } from "../data/types"

export function Section7Stats({ data }: { data: LandingData }) {
  return (
    <div className="copy-block stats-copy" data-motion="reveal">
      <p className="eyebrow mono">COVERAGE</p>
      <div className="stats-grid">
        <div><b>{data.stats.symbols}</b><span className="mono">SYMBOLS</span></div>
        <div><b>{data.stats.etfs}</b><span className="mono">ETFS</span></div>
        <div><b>{data.stats.exchanges}</b><span className="mono">EXCHANGES</span></div>
        <div><b>{data.stats.news_articles}</b><span className="mono">NEWS ARTICLES INDEXED</span></div>
      </div>
      <p className="sources mono">yfinance · akshare · SEC EDGAR · FRED · curated RSS. Local-first. Fallback-labeled. Stale-aware.</p>
    </div>
  )
}
